import PropTypes from 'prop-types'

export default function CardRow({
  children,
  className,
  align,
  direction,
  gap,
  justify,
  p,
  style,
  wrap,
  ...props
}) {
  const handleStyle = () => {
    const styleAttr = (style)? style : {}

    return {
      ...((align)? {alignItems: align}: {}),
      ...((direction)? {flexDirection: direction}: {}),
      ...((gap)? {gap: gap}: {}),
      ...((justify)? {justifyContent: justify}: {}),
      ...((p || p === 0)? {padding: p}: {}),
      ...((wrap)? {wrap: wrap}: {}),
      ...styleAttr,
    }
  }

  return (
    <div className={`dashboard-card-row ${className ? className : ''}`} {...props} style={handleStyle()}>
      {children}
    </div>)
}

CardRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  align: PropTypes.string,
  direction: PropTypes.string,
  gap: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  justify: PropTypes.string,
  p: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  className: PropTypes.string
}